/**
 * This method returns the account URL based on a given account & the current service type.
 * @return {string}
 */
export default (account, currentServiceType) => {
  const services = (account === null || account === void 0 ? void 0 : account.services) || [];
  const accountService = services.find(s => s.service_type === currentServiceType);
  return (accountService === null || accountService === void 0 ? void 0 : accountService.account_url) || account.account_url;
};
//# sourceMappingURL=getAccountUrl.js.map